import { format, parseISO } from 'date-fns';
import { formatarHora } from '../utils/helpers';
import api from './api';

export const buscaAgendasAbertas = async (payload) => {
  if (!payload.codMed) return [];

  const response = await api.get(
    `medico/agendaaberta/?&id=${payload.codMed}&dt=${payload.dtAgenda}`
  );

  // TODO: fazer isso no backend
  return response.data.map((agenda) => {
    const data = parseISO(String(agenda.DATAAGENDA).slice(0, 10));
    return {
      ...agenda,
      dataFormatada: format(data, 'dd/MM/yyyy'),
      hora: formatarHora(agenda.HORARIO),
      diaDaSemana: data.getDay() + 1,
    };
  });
};

export const buscaAgendaDoMedico = async ({ codMed, dtAgenda, verCanceladas = false }) => {
  const { data } = await api.get('medico/agendas', {
    params: {
      id: codMed,
      dt: dtAgenda,
      verCanceladas: verCanceladas ? 'true' : 'false',
    },
  });

  return data.map((agenda) => ({
    ...agenda,
    hora: formatarHora(agenda.HORARIO),
  }));
};

export const buscaHistoricoAgendaDoPaciente = async (codPac, codAgenda = null) => {
  const params = codAgenda ? { codAgenda } : {};
  const { data } = await api.get(`/pacientes/${codPac}/agendamentos/historico`, { params });
  return data || [];
};

export const buscaAgendaDoPaciente = async (codPac) => {
  const { data } = await api.get(`pacientes/${codPac}/agendamentos`);
  return data || [];
};

export const buscarPacientesPorNome = async ({ nome }) => {
  const { data } = await api.get('/pacientes', {
    params: {
      nome: nome.trim(),
    },
  });
  return data ?? [];
};

export const buscarProcedimentosAgenda = async () => {
  const { data } = await api.get('/procedimentos', {
    params: {
      limit: 1000,
    },
  });
  return Array.isArray(data) ? data : [];
};

export const buscarConveniosAgenda = async () => {
  const { data } = await api.get('/convenios', {
    params: {
      limit: 1000,
    },
  });
  return Array.isArray(data) ? data : [];
};

export const buscarValoresProcediConv = async () => {
  const { data } = await api.get('/atividades/valores-convenio');
  return Array.isArray(data) ? data : [];
};

export const criarAgenda = async (payload) => {
  const { data } = await api.post('/agenda', payload);
  return data;
};

export const editarAgenda = async (payload) => {
  const { data } = await api.put('/agenda', payload);
  return data;
};

export const atualizarAgenda = async (url, { arg }) => {
  const { data } = await api.put(url, arg);
  return data;
};

export const marcarSituacaoAgenda = async (codAgenda, situacao) => {
  const { data } = await api.put('/agenda', { codAgenda, situacao });
  return data;
};

export const atualizarSituacaoAgenda = async ({
  codAgenda,
  codConv,
  codPac,
  codMed,
  codProcedi,
  situacao,
}) => {
  const { data } = await api.put('/agenda', {
    codAgenda,
    codConv,
    codPac,
    codMed,
    codProcedi,
    situacao,
  });
  return data;
};

export const inserirEncaixe = async ({ codMedico, dataAgenda, horario, codFunc }) => {
  const { data } = await api.post('/encaixe', {
    codMedico,
    dataAgenda,
    horario,
    codFunc,
  });
  return data;
};

export const gerarHorariosAgenda = async ({ codMedico, dataAgenda, codFunc }) => {
  const { data } = await api.post('/gerar-horarios', {
    codMedico,
    dataAgenda,
    codFunc,
  });
  return data;
};

export const getAgendaKey = (agenda) => String(agenda?.CODAGENDA);
